const OrderInProgress = require('@/lib/Orders/OrderInProgress');
const StashedCart = require('@/lib/StashedCarts/StashedCart');
const { populate } = require('@/functions/objects');
const { toBool, toDate, toNullableInt, toNullableString } = require('@/functions/transform');

/**
 * A User Session object. It's used when switching between users.
 *
 * @constructor
 *
 * @param {object} data
 */
const UserSession = function (data = {}) {
    /**
     * @type {?number}
     */
    this.ID = null;

    /**
     * @type {?string}
     */
    this.apiKey = null;

    /**
     * @type {?Date}
     */
    this.lastLoginDatetime = null;

    /**
     * @type {?string}
     */
    this.lastScreen = null;

    /**
     * @type {OrderInProgress}
     */
    this.orderInProgress = new OrderInProgress();

    /**
     * @type {StashedCart[]}
     */
    this.stashedCarts = [];

    /**
     * @type {?string}
     */
    this.username = null;

    /**
     * Has this session been locked (by using the Lock Screen button or the device locking automatically?)
     *
     * @type {boolean}
     */
    this.isLocked = false;

    populate(this, data);
};

UserSession.prototype = {
    getHydrationMap() {
        return {
            apiKey: toNullableString,
            isLocked: toBool,
            ID: toNullableInt,
            lastLoginDatetime: toDate,
            lastScreen: {},
            orderInProgress: {
                model: OrderInProgress,
            },
            stashedCarts: {
                modelCollection: StashedCart,
            },
            username: toNullableString,
        };
    },

    /**
     * @param {StashedCart} stashedCart
     */
    addStashedCart(stashedCart) {
        let existingStash = this.stashedCarts.find((c) => c.thirdPartyRef === stashedCart.thirdPartyRef);
        if (existingStash) {
            // Update existing.
            let existingIndex = this.stashedCarts.indexOf(existingStash);
            this.stashedCarts[existingIndex] = stashedCart;
        } else {
            // Add to the start of the list.
            this.stashedCarts.unshift(stashedCart);
        }
    },

    deleteStashedCartByThirdPartyRef(thirdPartyRef) {
        for (let i = 0; i < this.stashedCarts.length; i++) {
            let stashedCart = this.stashedCarts[i];
            if (stashedCart.thirdPartyRef === thirdPartyRef) {
                this.stashedCarts.splice(i, 1);
                return true;
            }
        }
        return false; // Tell the calling code we couldn't find the requested cart.
    },
};

module.exports = UserSession;
